// src/router.js
import { createRouter, createWebHistory } from 'vue-router';

// Import existing components
// *** NOTE: We import the NEW HomePage and the component formerly known as HomePage as OwnTeamPage ***
import HomePage from './components/HomePage.vue'; // The NEW welcome page
import OwnTeamPage from './components/OwnTeamPage.vue'; // Your original HomePage content
import ProfilePage from './components/ProfilePage.vue'; // New profile page
import SignIn from './components/Auth/SignIn.vue';
import SignUp from './components/Auth/SignUp.vue';
import ConfirmSignUp from './components/Auth/ConfirmSignUp.vue';
import ForgotPassword from './components/Auth/ForgotPassword.vue';
import ResetPassword from './components/Auth/ResetPassword.vue';
import AuthCallback from './components/Auth/AuthCallback.vue';
import CompleteGoogleRegistration from './components/Auth/CompleteGoogleRegistration.vue';
import ResultsPage from './components/ResultsPage.vue';
import IntroductionPage from './components/IntroductionPage.vue';
import OwnGroupPage from './components/OwnGroupPage.vue';
import AiAssistantPage from './components/AiAssistantPage.vue';
import TermsOfService from './components/TermsOfService.vue';
import PrivacyPolicy from './components/PrivacyPolicy.vue';
import WithdrawalForm from './components/WithdrawalForm.vue';
import NewsPage from './components/NewsPage.vue';
import NewsArticlePage from './components/NewsArticlePage.vue';

const routes = [
  // *** "/" path now points to the NEW HomePage ***
  { path: '/', name: 'Home', component: HomePage },
  { path: '/uutiset', name: 'News', component: NewsPage },
  { path: '/uutiset/:slug', name: 'NewsArticle', component: NewsArticlePage, props: true },
  { path: '/sign-in', name: 'SignIn', component: SignIn },
  { path: '/sign-up', name: 'SignUp', component: SignUp },
  { path: '/confirm-sign-up', name: 'ConfirmSignUp', component: ConfirmSignUp },
  { path: '/forgot-password', name: 'ForgotPassword', component: ForgotPassword },
  { path: '/reset-password', name: 'ResetPassword', component: ResetPassword },
  { path: '/auth/callback', name: 'AuthCallback', component: AuthCallback },
  { path: '/complete-google-registration', name: 'CompleteGoogleRegistration', component: CompleteGoogleRegistration },

  // *** "/team" path now points to OwnTeamPage (your original HomePage logic) ***
  { path: '/team', name: 'MyTeam', component: OwnTeamPage, meta: { requiresAuth: true } }, // Added meta field
  { path: '/profile', name: 'Profile', component: ProfilePage, meta: { requiresAuth: true } }, // New profile page
  { path: '/results', name: 'Results', component: ResultsPage, meta: { requiresAuth: true }, props: route => ({
    initialView: route.query.view === 'archive' ? 'archive' : 'current',
    requestedStart: typeof route.query.start === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(route.query.start) ? route.query.start : '',
  }) },
  { path: '/periods', redirect: '/results' },
  { path: '/introduction', name: 'Introduction', component: IntroductionPage },
  { path: '/group', name: 'MyGroup', component: OwnGroupPage, meta: { requiresAuth: true } }, // Groups need auth
  { path: '/assistant', name: 'AiAssistant', component: AiAssistantPage, meta: { requiresAuth: true } },
  { path: '/terms-of-service', name: 'TermsOfService', component: TermsOfService },
  { path: '/privacy-policy', name: 'PrivacyPolicy', component: PrivacyPolicy },
  { path: '/peruuttamislomake', name: 'WithdrawalForm', component: WithdrawalForm },

  // Optional: Add a catch-all route for 404 Not Found
  // { path: '/:pathMatch(.*)*', name: 'NotFound', component: NotFoundComponent }
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  linkActiveClass: 'router-link-active',
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) return savedPosition;
    if (to.name === 'Home' && to.hash === '#ajankohtaista') return { el: to.hash, top: 24 };
    if (to.name === 'Home' && (from.name === 'News' || from.name === 'NewsArticle')) return { top: 0 };
    if (to.name === 'News' || to.name === 'NewsArticle') return { top: 0 };
  },
});

// --- Optional: Navigation Guard ---
// You can add a global navigation guard to check the `requiresAuth` meta field.
// This prevents users from even accessing the URL if not logged in.
// Note: You'd need a reliable way to check auth status synchronously here,
// or make the check asynchronous. Amplify's check is async, making this tricky
// without a state management library or waiting for the initial check in App.vue.
// For simplicity now, we rely on the v-if on links and internal component checks.

// Example (might need adjustments based on auth state availability):
/*
import { Auth } from 'aws-amplify'; // Import Auth if checking here

router.beforeEach(async (to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    try {
      await Auth.currentAuthenticatedUser(); // Check if user is logged in
      next(); // Proceed if logged in
    } catch (error) {
      // No user logged in, redirect to sign-in page
      console.log("Redirecting to sign-in because route requires auth.");
      next({ name: 'SignIn', query: { redirect: to.fullPath } }); // Redirect, optionally pass target path
    }
  } else {
    next(); // Doesn't require auth, proceed
  }
});
*/
// ---------------------------------

export default router;
